"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const ElementAttributeImageSwitcher_1 = __importDefault(require("@web/common/ElementAttributeImageSwitcher"));
const ElementViewportObserver_1 = __importDefault(require("@web/common/ElementViewportObserver"));
const ScreenSize_1 = __importDefault(require("@web/common/ScreenSize"));
(() => {
    const isSmallScreen = ScreenSize_1.default.isSmallScreen();
    function lazyLoadImage(observedElement, isBackground) {
        ElementViewportObserver_1.default.observeElement(observedElement, (element) => {
            ElementAttributeImageSwitcher_1.default.switch(element, isBackground, isSmallScreen);
        });
    }
    function init() {
        const imageElements = Array.from(document.getElementsByClassName('img-lazy-loading'));
        imageElements.forEach((element) => {
            lazyLoadImage(element, false);
        });
        const backgroundElements = Array.from(document.getElementsByClassName('bcg-lazy-loading'));
        backgroundElements.forEach((element) => {
            lazyLoadImage(element, true);
        });
    }
    init();
    document.addEventListener('ReactListingComponentDidMountEvent', () => {
        init();
    });
})();
